module.exports = __webpack_public_path__ + "static/img/feature_2.63bcec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/feature_2.png
// module id = PW1R
// module chunks = 0